import axios from "axios";
import { GetSessionID } from "./SessionID";
import { getCSRF } from "./CSRFhook";

interface GetHeadersInterface {
    url: string;
    data: any;
}

interface HeadersInterface {
    url: string;
    headers: any;
    data: any;
}

export function GetDataFetch({url, data}: GetHeadersInterface): any {
  let out = axios.get(url, data)
            .then(response => {
                    // 200 Response
                    return response.data;
                
            })
            .catch((err) => {
                if (err.response) {
                    // Server responded with a status other than 2xx 
                    console.log("Response error:", err.response.status);
                    console.log("Response error:", err.response);
                } else if (err.request) {
                    // No response was received
                    console.log("Request error:", err.request);
                } else {
                    // Something went wrong setting up the request
                    console.log("Error:", err.message);
                }

                return null;
            });

    return out;
}

export function PostDataFetch({url, headers, data}: HeadersInterface): any {
  let out = axios.post(url, data, headers)
            .then(response => {
                    // 200 Response
                    return response.data;
                
            })
            .catch((err) => {
                if (err.response) {
                    // Server responded with a status other than 2xx 
                    console.log("Response error:", err.response.status);
                    console.log("Response error:", err.response);
                } else if (err.request) {
                    // No response was received
                    console.log("Request error:", err.request);
                } else {
                    // Something went wrong setting up the request
                    console.log("Error:", err.message);
                }

                return null;
            });

    return out;
}

export function GetHeaders(): any {
    let axiosConfigOpt1 = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRFToken': getCSRF(),
            'app-session': ''
        },
        timeout: 30000
    };
    let axiosConfigOpt2 = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-CSRFToken': getCSRF(),
            'app-session': GetSessionID()
        },
        timeout: 30000
    };
    return GetSessionID() ? axiosConfigOpt2 : axiosConfigOpt1;
}